import axios from 'axios'
import { generateAuthHeader, clearAuthentication } from '../utils/authHelp'
import { loadingActions } from '../redux/actions/loadingActions'
import store from '../redux'
import { modalError, modalErrorRefreshCode, modalWarning } from '../utils/modalUtils'
import { redirectURL } from '../utils/authHelp'
import { formatMessage } from '../utils/common'
let commonStore = {}
store.subscribe(() => {
  const state = store.getState()
  commonStore = state.commonStore
})
let requstCounts = 0
let errorCount = 0
const instance = axios.create({
  // baseURL: process.env.REACT_APP_API_URL
  // timeout: 5000
})

// const whiteListReg = RegExp('/batches/[a-zA-Z0-9]{32}$')
// Add a request interceptor
instance.interceptors.request.use(
  async function(config) {
    // Do something before request is sent
    // Don't show Spin when searching split status
    // if (!(config.method === 'get' && whiteListReg.test(config.url))) {
    if (!config['noSpin']) {
      store.dispatch(loadingActions(true)) // show Spin Loading
      requstCounts++
    }
    const authHeaders = await generateAuthHeader()
    const RFHeader = config.RFHeader || {}
    config.headers = {
      ...config.headers,
      ...authHeaders,
      ...RFHeader
    }
    // 解决IE中网络请求相同url会从缓存中读取的问题，为每个请求增加一个_t参数
    config.headers['Cache-Control'] = 'no-cache'
    config.params = {
      ...config.params,
      _t: new Date().getTime()
    }
    return config
  },
  function(error) {
    // Do something with request error
    requstCounts = requstCounts - 1 < 0 ? 0 : requstCounts - 1
    requstCounts === 0 && store.dispatch(loadingActions(false))
    return Promise.reject(error)
  }
)

// Add a response interceptor
instance.interceptors.response.use(
  function(response) {
    // Do something with response data
    // if(response.config.method !== 'get'){
    requstCounts = requstCounts - 1 < 0 ? 0 : requstCounts - 1
    requstCounts === 0 && store.dispatch(loadingActions(false))
    // }
    const { config } = response
    const data = response.data || {}
    const errorCode = data.errorCode || data.errorcode

    if (errorCode) {
      if (errorCode === '200' || errorCode === 200) {
        return response.data
      } else if (errorCode === '401') {
        if (config.nfc) {
          return Promise.reject(response.data)
        }
        if (errorCount > 0) {
        } else {
          errorCount++
          modalError(
            {
              content: formatMessage(commonStore, 'languageObj.httpLocale.tokenInvalid')
            },
            () => {
              errorCount = 0
              clearAuthentication()
              window.location.href = redirectURL
            }
          )
        }
        return Promise.reject(response)
      } else if (errorCode === '403') {
        if (errorCount > 0) {
        } else {
          errorCount++
          modalError(
            {
              content: formatMessage(commonStore, 'languageObj.httpLocale.notNfcUser')
            },
            () => {
              errorCount = 0
            }
          )
        }
        return Promise.reject(response)
      } else if (errorCode === '410') {
        if (errorCount > 0) {
        } else {
          errorCount++
          modalError(
            {
              content: formatMessage(commonStore, 'languageObj.httpLocale.loginNameExists')
            },
            () => {
              errorCount = 0
            }
          )
        }
        return Promise.reject(response)
      } else if (errorCode === '411') {
        if (errorCount > 0) {
        } else {
          errorCount++
          modalError(
            {
              content: formatMessage(commonStore, 'languageObj.httpLocale.accountExpired')
            },
            () => {
              errorCount = 0
            }
          )
        }
        return Promise.reject(response)
      } else if (errorCode === '413') {
        if (errorCount > 0) {
        } else {
          errorCount++
          modalError(
            {
              content: formatMessage(commonStore, 'languageObj.httpLocale.codeInvalid')
            },
            () => {
              errorCount = 0
            }
          )
        }
        return Promise.reject(response)
      } else if (errorCode === '414') {
        if (errorCount > 0) {
        } else {
          errorCount++
          modalError(
            {
              content: formatMessage(commonStore, 'languageObj.loginLocale.oktaError')
            },
            () => {
              errorCount = 0
              clearAuthentication()
              window.location.href = redirectURL
            }
          )
        }
        return Promise.reject(response)
      } else if (errorCode === '421') {
        return Promise.reject(response.data)
      } else if (errorCode === '442') {
        return Promise.reject(response.data)
      } else if (errorCode === '433') {
        return Promise.reject(response.data)
      } else if (errorCode === '435') {
        return Promise.reject(response.data)
      } else if (errorCode === '441') {
        return Promise.reject(response.data)
      } else if (errorCode === '5002') {
        return Promise.reject(response.data)
      } else if (errorCode === '5003') {
        return Promise.reject(response.data)
      } else if (errorCode === '412') {
        return Promise.reject(response.data)
      } else if (
        errorCode === '499' ||
        errorCode === '801' ||
        errorCode === '821' ||
        errorCode === '1111' ||
        errorCode === '1801' ||
        errorCode === '1308' ||
        errorCode === '1301'
      ) {
        return Promise.reject(response.data)
      } else if (errorCode === '601') {
        return Promise.reject(response.data)
      } else if (errorCode === '602') {
        return Promise.reject(response.data)
      } else if (errorCode === '603') {
        return Promise.reject(response.data)
      } else {
        if (config.uploadSku) {
          if (errorCode === '423') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.httpLocale.uploadSku') + data.resultData
            })
          } else if (errorCode === '424') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.httpLocale.blankCode')
            })
          } else if (errorCode === '425') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.httpLocale.blanksCode') + data.resultData
            })
          } else {
            if (!config.hiddenError) {
              // logistic error
              modalError({ content: formatMessage(commonStore, 'languageObj.httpLocale.requestError') })
            }
          }
        } else if (config.refreshCode) {
          if (errorCode === '1103') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.httpLocale.configError')
            })
          } else if (errorCode === '1111') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.httpLocale.sourceFileIsEmpty')
            })
          } else if (errorCode === '1110') {
            const data = response.data.resultData
            const path = data.replaceAll('/', '\\')
            modalWarning({
              content: formatMessage(commonStore, 'languageObj.httpLocale.sourceDirIsEmpty') + ': ' + path
            })
          } else if (errorCode === '1107') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.httpLocale.insertError')
            })
          } else if (errorCode === '499') {
            let msg = ''
            const data = response.data.resultData
            const keys = Object.keys(data)
            if (keys.indexOf('423') !== -1) {
              msg =
                msg + formatMessage(commonStore, 'languageObj.httpLocale.uploadSku') + data['423'].join('、') + '<br/>'
            }
            if (keys.indexOf('424') !== -1) {
              msg = msg + formatMessage(commonStore, 'languageObj.httpLocale.blankCode') + '<br/>'
            }
            if (keys.indexOf('425') !== -1) {
              msg = msg + formatMessage(commonStore, 'languageObj.httpLocale.blanksCode') + data['425'].join('、')
            }
            modalErrorRefreshCode({
              content: msg
            })
          } else if (errorCode === '1105') {
            let msg = ''
            const data = response.data.resultData
            const keys = Object.keys(data)
            for (let i = 0; i < keys.length; i++) {
              const key = keys[i]
              const value = data[key]
              switch (value) {
                case '1112':
                  msg =
                    msg +
                    key +
                    formatMessage(commonStore, 'languageObj.waverun.errorcode_1112') +
                    (i === keys.length - 1 ? '' : '<br/>')
                  break
                case '1113':
                  msg =
                    msg +
                    key +
                    formatMessage(commonStore, 'languageObj.waverun.errorcode_1113') +
                    (i === keys.length - 1 ? '' : '<br/>')
                  break
                case '1114':
                  msg =
                    msg +
                    key +
                    formatMessage(commonStore, 'languageObj.waverun.errorcode_1114') +
                    (i === keys.length - 1 ? '' : '<br/>')
                  break
                case '1111':
                  msg =
                    msg +
                    key +
                    formatMessage(commonStore, 'languageObj.waverun.errorcode_1111') +
                    (i === keys.length - 1 ? '' : '<br/>')
                  break
                case '500':
                  msg =
                    msg +
                    key +
                    formatMessage(commonStore, 'languageObj.waverun.errorcode_500') +
                    (i === keys.length - 1 ? '' : '<br/>')
                  break
                default:
                  break
              }
            }
            modalErrorRefreshCode({
              content: msg
            })
          } else if (errorCode === '1104') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.waverun.errorcode_1104')
            })
          } else if (errorCode === '1200') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.waverun.errorcode_1200')
            })
          } else if (errorCode === '1201') {
            modalWarning({
              content: formatMessage(commonStore, 'languageObj.waverun.errorcode_1201')
            })
          } else if (errorCode === '1202') {
            modalError({
              content: formatMessage(commonStore, 'languageObj.waverun.errorcode_1202')
            })
          } else if (errorCode === '1500') {
            let msg = ''
            const data = response.data.resultData
            for (let i = 0; i < data.length; i++) {
              const item = data[i]
              const errorCode = item.errorCode
              const resultData = item.resultData
              switch (errorCode) {
                case '1110':
                  const path = resultData.replaceAll('/', '\\')
                  msg =
                    msg + formatMessage(commonStore, 'languageObj.httpLocale.sourceDirIsEmpty') + ': ' + path + '<br/>'
                  break
                case '1105':
                  const keys = Object.keys(resultData)
                  for (let i = 0; i < keys.length; i++) {
                    const key = keys[i]
                    const value = resultData[key]
                    switch (value) {
                      case '1112':
                        msg =
                          msg +
                          key +
                          formatMessage(commonStore, 'languageObj.waverun.errorcode_1112') +
                          (i === keys.length - 1 ? '' : '<br/>')
                        break
                      case '1113':
                        msg =
                          msg +
                          key +
                          formatMessage(commonStore, 'languageObj.waverun.errorcode_1113') +
                          (i === keys.length - 1 ? '' : '<br/>')
                        break
                      case '1114':
                        msg =
                          msg +
                          key +
                          formatMessage(commonStore, 'languageObj.waverun.errorcode_1114') +
                          (i === keys.length - 1 ? '' : '<br/>')
                        break
                      case '1111':
                        msg =
                          msg +
                          key +
                          formatMessage(commonStore, 'languageObj.waverun.errorcode_1111') +
                          (i === keys.length - 1 ? '' : '<br/>')
                        break
                      case '500':
                        msg =
                          msg +
                          key +
                          formatMessage(commonStore, 'languageObj.waverun.errorcode_500') +
                          (i === keys.length - 1 ? '' : '<br/>')
                        break
                      default:
                        break
                    }
                  }
                  break
                default:
                  break
              }
            }
            modalErrorRefreshCode({
              content: msg
            })
          }
        } else if (config.PFTagBinding) {
          return Promise.reject(response.data)
        } else {
          if ((errorCode === '420' || errorCode === '951') && config.reSend) {
            return response.data
          }
          if (
            errorCode === '2207' ||
            errorCode === '2208' ||
            errorCode === '2209' ||
            errorCode === '2210' ||
            errorCode === '2211' ||
            errorCode === '2212' ||
            errorCode === '2213' ||
            errorCode === '2214'
          ) {
            return Promise.reject(response.data)
          }
          if (config.nfc) {
            return Promise.reject(response.data)
          }
          if (!config.hiddenError) {
            // logistic error
            modalError({ content: formatMessage(commonStore, 'languageObj.httpLocale.requestError') })
          }
        }
        return Promise.reject(response.data)
      }
    } else {
      if (config.uploadOrDownload) {
        return response
      }
      if (config.nfc) {
        return response.data
      }
      return Promise.reject(response)
    }
  },
  function(error) {
    // Do something with response error
    requstCounts = requstCounts - 1 < 0 ? 0 : requstCounts - 1
    requstCounts === 0 && store.dispatch(loadingActions(false))
    const { response } = error

    if (error.config.mac) {
      return Promise.reject(error)
    }
    if (!error.config.hiddenError) {
      if (response) {
        switch (response.status) {
          case 401:
          case '401':
            if (errorCount > 0) {
            } else {
              errorCount++
              modalError({ content: formatMessage(commonStore, 'languageObj.httpLocale.tokenInvalid') }, () => {
                errorCount = 0
                clearAuthentication()
                window.location.href = redirectURL
              })
            }
            break
          case 404:
          case '404':
            modalError({ content: formatMessage(commonStore, 'languageObj.httpLocale.code404') })
            break
          case 504:
          case '504':
            modalError({ content: formatMessage(commonStore, 'languageObj.httpLocale.timeOut') })
            break
          case 500:
          case '500':
            modalError({ content: formatMessage(commonStore, 'languageObj.httpLocale.systemError') })
            break
          default:
            modalError({ content: formatMessage(commonStore, 'languageObj.httpLocale.requestError') })
            break
        }
      } else {
        if (error.config.nfc) {
          return Promise.reject(error)
        } else {
          modalError({ content: formatMessage(commonStore, 'languageObj.httpLocale.requestError') })
        }
      }
    }

    return Promise.reject(error)
  }
)
export default instance
